import { NavMarker } from 'react-rhumb';
import { isSearchErrorBlocklistPortal } from '../isSearchErrorBlocklistPortal';
import { jsx as _jsx } from "react/jsx-runtime";
export const CRM_SEARCH_ERROR_HANDLED = 'CRM_SEARCH_ERROR_HANDLED';
export const CRM_SEARCH_ERROR_UNHANDLED = 'CRM_SEARCH_ERROR_UNHANDLED';
export const CrmSearchErrorNavMarker = ({
  name
}) => {
  const isBlocklistPortal = isSearchErrorBlocklistPortal();
  if (isBlocklistPortal && name === CRM_SEARCH_ERROR_UNHANDLED) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: CRM_SEARCH_ERROR_HANDLED
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: name
  });
};